import React from 'react';
import Select from 'react-select';
import TableCell from '../table/TableCell';
import ArrowDown from '../svg/ArrowDown';
import ArrowUp from '../svg/ArrowUp';
import ArrowLeft from '../svg/ArrowLeft';
import ArrowRight from '../svg/ArrowRight';
import IconButton from '../ActionIcons/IconButton';
import usePagination, { IPaginationConfig } from './usePagination';
import { disabledGrey, defaultGrey } from '../../prop-types';
import TableFooter from '../table/TableFooter';
import TableRow from '../table/TableRow';
import SelectInput, { IOption }from '../SelectInput';


interface IPaginationProps extends IPaginationConfig {
}

export default function Pagination(props: IPaginationProps) {
  const {
    readOnly,
    totalItemCount,
    pageSizes = [10, 20, 50],
    currentPage = 0,
    colSpanLength,
    currentPageSize = pageSizes[0],
    onChangePage,
    onChangePageSize
    } = props;

  const {
    bounds,
    startItemPos,
    endItemPos,
  } = usePagination(props);



  const selectStyles = {
    control: (styles: any) => ({ ...styles, backgroundColor: 'white', border: 'none'}),
    valueContainer: (styles: any) => ({ ...styles,
      padding: '0px',
      justifyContent: 'center'
    }),
    option: (styles: any, { data = {}, isDisabled= false, isFocused = false, isSelected = false }) => {
      return {
        ...styles,
        textAlign: 'center',
        backgroundColor: isFocused ? disabledGrey : 'white',
        color: 'inherit',
        cursor: isDisabled ? 'not-allowed' : 'default',
        border: 'none',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
      };
    }
  };

  const selectOptions: IOption[] = pageSizes.map( pageSize => {
    return { value: pageSize.toString(), label: pageSize.toString()}
  });
  const currentOption: IOption = {value: currentPageSize.toString(), label: currentPageSize.toString()}


  return (
    <TableFooter>
      <TableRow>
        <TableCell className="borderless" variant="footer" colspan={readOnly? colSpanLength: colSpanLength + 1}>
          <div className="table_cell_footer right-align borderless">
            <span>
              Reihen pro Seite:
            </span>
            <div className="select-containter">
              <SelectInput
                options={selectOptions}
                initialOption={currentOption}
                type="number"
                onChange={
                  (option: IOption) => onChangePageSize(parseInt(option.value))
                }/>
            </div>
            <div>

            <span>
              {`${startItemPos} - ${endItemPos} von ${totalItemCount}`}
            </span>

            <IconButton
              disabled={bounds.left}
              onClick={() => { onChangePage(currentPage -1)}}
            >
              <ArrowLeft color={(bounds.left? disabledGrey : defaultGrey)}/>
            </IconButton>
            <IconButton
              disabled={bounds.right}
              onClick={() => { onChangePage(currentPage + 1)}}
            >
              <ArrowRight color={(bounds.right? disabledGrey : defaultGrey)}/>
            </IconButton>
          </div>
        </div>
        </TableCell>
      </TableRow>
    </TableFooter>
  );
}
